import { combineReducers } from "redux";
import homeReducer     from "./HomeReducer";
import searchReducer   from "./SearchReducer";
import checkoutReducer from "./CheckoutReducer";
import loginReducer    from "./LoginReducer";

/* 
export default combineReducers({
   
    homeReducer,
    searchReducer,
    checkoutReducer,
    loginReducer,
})

 */
const appReducer = combineReducers({
   
    homeReducer,
    searchReducer,
    checkoutReducer,
    loginReducer,
})

export default (state,action)=>{
    if(action.type === 'RESTORE'){
        state = undefined
    }
   return appReducer(state,action)
}

